import React from 'react';
import { CheckCircle2, ThumbsUp, Clock, Pencil, FileEdit, File, AlertCircle, Minus } from 'lucide-react';
import { ReportStato, ValidationStatus } from '../api/apiTypes';

type Props = {
  stato: ReportStato | ValidationStatus;
};

const ReportStatusBadge: React.FC<Props> = ({ stato }) => {
  const isCompleted  = ['drafted', 'approved', 'completed', 'validated'].includes(stato);
  const isToValidate = stato === 'required';

  const getLabel = () => {
    switch (stato) {
      case 'generated':    return 'Generato';
      case 'empty':        return 'Vuoto';
      case 'edited':       return 'Modificato';
      case 'validated':    return 'Validato';
      case 'required':     return 'Da Validare';
      case 'not_required': return 'Non Richiesta';
      case 'drafted':      return 'In elaborazione';
      case 'approved':     return 'Approvato';
      case 'completed':    return 'Completato';
      default:             return stato;
    }
  };

  const colorCls = isCompleted
    ? 'text-stateCompletedText'
    : isToValidate
    ? 'text-stateToValidateText'
    : 'text-statePendingText';

  const getIcon = () => {
    switch (stato) {
      case 'completed':    return <CheckCircle2 className={`w-3.5 h-3.5 ${colorCls}`} />;
      case 'approved':     return <ThumbsUp     className={`w-3.5 h-3.5 ${colorCls}`} />;
      case 'validated':    return <CheckCircle2 className={`w-3.5 h-3.5 ${colorCls}`} />;
      case 'drafted':      return <Pencil       className={`w-3.5 h-3.5 ${colorCls}`} />;
      case 'generated':    return <Clock        className={`w-3.5 h-3.5 ${colorCls}`} />;
      case 'edited':       return <FileEdit     className={`w-3.5 h-3.5 ${colorCls}`} />;
      case 'empty':        return <File         className={`w-3.5 h-3.5 ${colorCls}`} />;
      case 'required':     return <AlertCircle  className={`w-3.5 h-3.5 ${colorCls}`} />;
      case 'not_required': return <Minus        className={`w-3.5 h-3.5 ${colorCls}`} />;
      default:             return <Clock        className={`w-3.5 h-3.5 ${colorCls}`} />;
    }
  };

  return (
    <span className="flex items-center gap-1.5">
      {getIcon()}
      <span className="text-[11px] font-medium text-gray-600">{getLabel()}</span>
    </span>
  );
};

export default ReportStatusBadge;
